import React from 'react';

interface TimeSpanV2Props {
    timeSpanInSeconds: number;
}

const TimeSpanV2: React.FC<TimeSpanV2Props> = ({ timeSpanInSeconds }) => {
    const formatTime = (seconds: number): string => {
        const hours = Math.floor(seconds / 3600);
        seconds %= 3600;
        const minutes = Math.floor(seconds / 60);
        seconds %= 60;

        let result = '';
        if (hours > 0) result += `${hours} h `;
        if (minutes > 0) result += `${minutes} m `;
        if (seconds > 0) result += `${seconds} s`;

        return result.trim();
    };

    const result = formatTime(timeSpanInSeconds);

    return (
        <div>
            {result}
        </div>
    );
};

export default TimeSpanV2;